// Recipient wallet principal. Set it once the site is registered in Pybara
// Wallet (Manage > Sites > Add a site without a plugin) with the `_pybara-payto`
// DNS record published and the widget terms accepted. The widget hides itself
// until all of that is in place; the console reports why.
const RECIPIENT_PRINCIPAL = 'fwlxg-uu4bi-5cxlr-siw7b-etj5i-vhc4n-p77g3-ng6lh-ftbvj-6nfeu-uqe';

if (RECIPIENT_PRINCIPAL && window.PybaraDonate) {
    window.PybaraDonate.init({
        target: '#pybara-donate',
        recipientPrincipal: RECIPIENT_PRINCIPAL,
        siteUrl: 'https://yogabuild.eu',
        siteName: 'Yogabuild',
        theme: 'dark',
        primaryColor: '#56277f',
        presetAmounts: [10, 25, 50, 100],
        title: 'Support our work',
        description: 'Every donation helps us keep building open-source tooling on the Internet Computer.',
    });
} else {
    console.warn('PybaraDonate: RECIPIENT_PRINCIPAL is not set in js/donate.js — widget disabled.');
}
